import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";
import _ from "lodash";

function* getLatestSchema(action) {
    try {
        // Get Server Info
        const server = yield call(() =>
            configurationsAPI.getServer({
                serverId: action.payload.serverId
            })
        );

        // Get Hall Info
        const basicInfo = yield call(() =>
            configurationsAPI.getHallInfo({ hallId: server.data.hall_id })
        );

        yield put({
            type: ConfigurationsActionTypes.GET_HALL_BASIC_INFO_SUCCESS,
            payload: {
                hall: basicInfo.data,
                server: server.data
            }
        });

        // Get Denominations
        try {
            yield put({
                type: ConfigurationsActionTypes.GET_DENOMINATIONS,
                payload: {
                    countryId: basicInfo.data.subsidiary.country.id
                }
            });
        } catch (e) {
            API.handleError(e.response, "Error getting Denominations.");

            yield put({
                type: ConfigurationsActionTypes.GET_DENOMINATIONS_FAIL,
                payload: e
            });
        }

        //Get currencies
        try {
            yield put({
                type: ConfigurationsActionTypes.GET_CURRENCIES,
                payload: {
                    subsidiaryId: basicInfo.data.subsidiary.id
                }
            });
        } catch (e) {
            API.handleError(e.response, "Error getting Currencies.");

            yield put({
                type: ConfigurationsActionTypes.GET_CURRENCIES_FAIL,
                payload: e
            });
        }

        // Get Latest Schema
        try {
            const subsidiaryId = basicInfo.data.subsidiary.id;

            const core_versions = yield call(() =>
                configurationsAPI.getCoreVersions()
            );

            let json_version = core_versions.data.results.filter(version => {
                return version.version === server.data.system_server_version;
            });

            if (json_version.length == 0) {
                const versions = core_versions.data.results.map(version => {
                    return version.version;
                });
                versions.sort();
                json_version = core_versions.data.results.filter(version => {
                    return version.version === versions[0];
                });
            }

            const latest = yield call(() =>
                configurationsAPI.getSchema(
                    subsidiaryId,
                    json_version[0].sub_versions.config_json,
                    server.data.type
                )
            );

            yield put({
                type: ConfigurationsActionTypes.UPDATE_NECESSARY_VALIDS,
                payload: {
                    length: Object.keys(latest.data.components).length
                }
            });

            yield put({
                type: ConfigurationsActionTypes.GET_LATEST_SCHEMA_SUCCESS,
                payload: latest.data
            });
        } catch (e) {
            API.handleError(e.response, "Error getting configuration schema.");

            yield put({
                type: ConfigurationsActionTypes.GET_LATEST_SCHEMA_FAIL,
                message: e.message
            });
        }
    } catch (e) {
        API.handleError(e.response, "Error getting Basic Hall Information");

        yield put({
            type: ConfigurationsActionTypes.GET_HALL_BASIC_INFO_FAIL,
            payload: e
        });
    }
}

export function* getLatestSchemaWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_LATEST_SCHEMA,
        getLatestSchema
    );
}

export function* getProgressivesRulesWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_PROGRESSIVES_RULES,
        getProgressiveRules
    );
}

function* getProgressiveRules(action) {
    try {
        const types = yield call(() => configurationsAPI.getProgressiveTypes());
        const presets = yield call(() =>
            configurationsAPI.getProgressivePresets(
                action.payload.subsidiary,
                action.payload.isDetail,
                action.payload.isDebug
            )
        );
        const rules = yield call(() => configurationsAPI.getProgressiveRules());

        let progressiveRules = {};
        Object.keys(types.data).map(key => {
            const progressive = types.data[key];
            progressiveRules[progressive] = {
                type: key,
                prizes: _.find(rules.data, rule => {
                    return rule.type == key;
                }).prizes,
                presets: _.filter(presets.data.results, preset => {
                    return preset.type == key;
                })
            };
        });

        yield put({
            type: ConfigurationsActionTypes.GET_PROGRESSIVES_RULES_SUCCESS,
            payload: progressiveRules
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Progressive Rules");

        yield put({
            type: ConfigurationsActionTypes.GET_PROGRESSIVES_RULES_FAIL,
            payload: e
        });
    }
}